import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import APIHelper from '../HelperMethodsForAPI'
interface reqVUTarget {
    TargetInputType: number
    defaultTargetId: number
    userTargetId: number
    userRubricId: number
    dashBoardId: number
    visualUnitId: number
    metaDataId: number
    aggregateFunction: string
    targetValue: number
    targetType: number
    changePreset: boolean //set global measure
    setKMI: boolean
    emailNotifyOnce: boolean
    DataType: string //FP-10376.
    usePreset: boolean
    subvisualUnitId: number
}

interface reqDeleteVUTarget {
    visualUnitId: number
    metaDataId: number
    aggregateFunction: string
    userTargetId: number // send usertargetid always (in case of use preset this user will derefernce from global target usage)
    defaultTargetId: number
    userRubricId: number
    changePreset: boolean
    subvisualUnitId: number
}

const baseUrl = `${getBaseUrl()}API/v3/visualunit`
export const VuTarget = createApi({
    reducerPath: 'VuTarget',
    baseQuery: getBaseQuery(baseUrl),
    endpoints: (builder) => ({
        Savetarget: builder.mutation<any, reqVUTarget>({
            query: (body) => ({
                url: '/Target',
                method: 'POST',
                body: APIHelper.prepareFormData(body),
            }),
        }),
        Deletetarget: builder.mutation<any, reqDeleteVUTarget>({
            query: (body) => ({
                url: `/${body.visualUnitId}/DeleteTarget`,
                method: 'DELETE',
                body: APIHelper.prepareFormData(body),
            }),
        }),
    }),
})

export const { useSavetargetMutation, useDeletetargetMutation } = VuTarget
